if(!global.__reanimatedWorkletInit){global.__reanimatedWorkletInit=function(){};}